// src/EnhancedComponents/ErrorBoundary.js
import React from "react";
import { Alert, AlertTitle, Button } from "@mui/material";

/** Keeps a crash in one page from blanking the whole admin panel. */
export default class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Page crashed:", error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <Alert
        severity="error"
        action={
          <Button color="inherit" size="small" onClick={() => window.location.reload()}>
            Reload
          </Button>
        }
      >
        <AlertTitle>Something went wrong</AlertTitle>
        This page failed to load. Try reloading; if it keeps happening, contact the
        administrator.
      </Alert>
    );
  }
}
